















import Vue from 'vue';
import { mapGetters } from 'vuex';

import BoxWrapper from '../../components/box-wrapper.vue';
import RegisterProgress from '../../components/register-progress.vue';
import { makeMetaInfo } from '../../router/utils/meta';
import PhotoForm from './form.vue';
import * as RegistrationStore from '../../store/modules/register';
import * as ErrorStore from '../../store/modules/error';
import * as UiStore from '../../store/modules/ui';

export default Vue.extend({
  metaInfo: makeMetaInfo({ title: '証明写真' }),
  components: {
    BoxWrapper,
    PhotoForm,
    RegisterProgress,
  },
  computed: {
    ...mapGetters(RegistrationStore.namespace, ['profileInfo']),
    ...mapGetters(ErrorStore.namespace, ['errors']),
    ...mapGetters(UiStore.namespace, ['isLoading']),
  },
  mounted() {
    if (!this.profileInfo || !this.profileInfo.email) {
      this.$router.replace({ name: 'cv_path' });
    }
  },
  methods: {
    async onSubmit() {
      this.$router.push({ name: 'preview_path' });
    },
    async onChangeProfileImage(
      profile_image: RegistrationStore.ProfileInfo['profile_image']
    ) {
      await this.$store.dispatch(
        RegistrationStore.UpdateProfileInfo.namespaced({
          ...this.profileInfo,
          profile_image,
        })
      );
    },
  },
});
